"use client";

import EsimPackageCover from "@/components/esim/EsimPackageCover";
import Text from "@/components/common/Typography/Text";
import Title from "@/components/common/Typography/Title";
import { useEsimProductHomeContent } from "@/hooks/esim/useEsimProductHomeContent";
import { sanitizeCmsHtml } from "@/utils/html/sanitizeCmsHtml";
import { Skeleton, Tabs } from "antd";
import { FC } from "react";

const asText = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

/** Card cho 1 content — banner (nếu có) + phần thân giới hạn chiều cao (cuộn dọc nếu dài hơn). */
const ProductHomeContentCard: FC<{ data: Record<string, unknown> }> = ({ data }) => {
  const html = asText(data.html);
  const banner = asText(data.banner);
  const title = asText(data.title);
  const description = asText(data.description);

  return (
    <div className="esim-hub__product-content-card">
      {banner && (
        <EsimPackageCover
          imageUrl={banner}
          height={220}
          className="esim-hub__product-content-banner"
        />
      )}
      <div className="esim-hub__product-content-body">
        {html ? (
          // <div
          //   className="esim-hub__product-content-html"
          //   dangerouslySetInnerHTML={{ __html: html }}
          // />
          <div
            className="esim-hub__product-content-html rich-text"
            dangerouslySetInnerHTML={{ __html: sanitizeCmsHtml(html) }}
          />
        ) : (
          <>
            {title && (
              <Title level={4} style={{ marginTop: 0, marginBottom: description ? 8 : 0 }}>
                {title}
              </Title>
            )}
            {description && <Text type="secondary">{description}</Text>}
          </>
        )}
      </div>
    </div>
  );
};

/**
 * Content đứng độc lập cho trang chủ eSIM (`product_content.position` chứa `PRODUCT_HOME`) — đứng ngay
 * dưới "Khám phá thế giới". 1 bài thì hiện thẳng, nhiều bài thì hiện dạng tab (mỗi content 1 tab).
 */
const EsimProductHomeContent: FC = () => {
  const { resolved, loading } = useEsimProductHomeContent();

  if (loading) {
    return (
      <section className="esim-hub__product-content" aria-hidden>
        <div className="esim-hub__product-content-card">
          <Skeleton.Image active style={{ width: "100%", height: 220 }} />
          <div className="esim-hub__product-content-body">
            <Skeleton active title paragraph={{ rows: 3 }} />
          </div>
        </div>
      </section>
    );
  }

  if (!resolved.length) return null;

  if (resolved.length === 1) {
    return (
      <section className="esim-hub__product-content">
        <ProductHomeContentCard data={resolved[0].data} />
      </section>
    );
  }

  return (
    <section className="esim-hub__product-content">
      <Tabs
        className="esim-hub__product-content-tabs"
        items={resolved.map((entry, idx) => ({
          key: entry.item.id,
          label: entry.item.displayName || asText(entry.data.title) || `Nội dung ${idx + 1}`,
          children: <ProductHomeContentCard data={entry.data} />,
        }))}
      />
    </section>
  );
};

export default EsimProductHomeContent;
